var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDislikeOutcome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.80037 13.8004C7.35248 13.8004 7.80006 13.3528 7.80006 12.8007L7.80006 12.0009C7.80006 10.107 9.18604 8.53677 10.9991 8.24919L10.9991 4.00341C10.9991 3.0096 10.1934 2.20397 9.19963 2.20397L3.60136 2.20397C3.58439 2.20397 3.56743 2.20324 3.55052 2.20181C3.28711 2.1794 2.79885 2.44444 2.588 3.33139L1.80328 7.25501C1.83063 7.78268 2.26714 8.20211 2.80161 8.20211L5.20087 8.20211C5.53213 8.20211 5.80068 8.47065 5.80068 8.80192L5.80068 12.8007C5.80068 13.3528 6.24826 13.8004 6.80037 13.8004ZM11.1666 1.73939C10.64 1.28153 9.9522 1.00434 9.19963 1.00434L3.62431 1.00434C2.48123 0.924689 1.67867 1.95429 1.41788 3.06675C1.41638 3.07315 1.41498 3.07958 1.41369 3.08602L0.61394 7.08478C0.606193 7.12351 0.602292 7.16292 0.602292 7.20242C0.602292 8.41707 1.58696 9.40173 2.80161 9.40173L4.60105 9.40173L4.60105 12.8007C4.60105 14.0153 5.58572 15 6.80037 15C8.01502 15 8.99969 14.0153 8.99969 12.8007L8.99969 12.0009C8.99969 10.5654 10.1634 9.40173 11.5989 9.40173L13.9981 9.40174C14.7711 9.40174 15.3977 8.77513 15.3977 8.00217L15.3977 2.4039C15.3977 1.63095 14.7711 1.00434 13.9981 1.00434L12.3986 1.00434C11.8662 1.00434 11.4032 1.30169 11.1666 1.73939ZM12.1987 8.20211L13.9981 8.20211C14.1086 8.20211 14.1981 8.11259 14.1981 8.00217L14.1981 2.4039C14.1981 2.29348 14.1086 2.20397 13.9981 2.20397L12.3986 2.20397C12.2882 2.20397 12.1987 2.29348 12.1987 2.4039L12.1987 8.20211Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeOutcome);
export default __webpack_public_path__ + "static/media/dislike_outcome.2b469ec19ca3b10e2b7c12168ce92b31.svg";
export { ForwardRef as ReactComponent };